import React from "react";

const AccountingTabs = ({
    activeTab,
    onChange,
    ledgerCount,
    groupCount,
}) => {

    return (
        <div className="accounting-tabs">

            <button
                className={
                    activeTab === "ledgers"
                        ? "accounting-tab active"
                        : "accounting-tab"
                }
                onClick={() => onChange("ledgers")}
            >
                <span>
                    Ledgers
                </span>

                <b>
                    {ledgerCount}
                </b>
            </button>


            <button
                className={
                    activeTab === "groups"
                        ? "accounting-tab active"
                        : "accounting-tab"
                }
                onClick={() => onChange("groups")}
            >
                <span>
                    Account Groups
                </span>

                <b>
                    {groupCount}
                </b>
            </button>

        </div>
    );
};

export default AccountingTabs;
